import { render, staticRenderFns } from "./WapLYT001View.vue?vue&type=template&id=60edc5fc&"
import script from "./WapLYT001View.vue?vue&type=script&lang=js&"
export * from "./WapLYT001View.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports